<app-si-dialog
    [hideHeader]="true"
    modalFooterClasses="si-dialog__footer--centered"
    [saveButtonClass]="isAvailabilityModal ? null : 'mat-error'"
    [saveButtonText]="submitBtnText"
    (save)="onConfirmation(true)"
>
    <ng-template appDialogBody>
        <div class="px-16 py-8">
            <div class="flex items-center gap-5">
                <fa-icon class="shrink-0 mt-0.5" [ngClass]="isAvailabilityModal ? 'text-primary-light' : 'text-danger'" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
                <p class="m-0 max-w-[32rem] break-words text-base leading-6">
                    {{ confirmMessage }}
                </p>
            </div>
        </div>
    </ng-template>
</app-si-dialog>
